import React, { createContext, useState, useContext, FC } from 'react';

export const useUserContextController = () => {
  const [account, setAccount] = useState('');

  const isWalletConnected = account !== '0x0000000000000000000000000000000000000001';

  return {
    account,
    setAccount,
    isWalletConnected,
  } as const;
};

export const UserContext = createContext<ReturnType<typeof useUserContextController> | null>(null);

export const useUserContext = () => {
  const value = useContext(UserContext);
  if (value === null) {
    throw new Error(`[User Context] useUserContext must be called within UserContext tree`);
  }
  return value;
};

export const UserContextProvider: FC = ({ children }) => {
  const contextController = useUserContextController();

  return <UserContext.Provider value={contextController}>{children}</UserContext.Provider>;
};
